const messages = {
  name: 'Default Pricing',
  dialog: {
    title: 'Default Pricing Details',
  },
  actions: {
    addDefaultPricing: 'Add Default Pricing',
  },
  fields: {
    communicationChannel: 'Communication Channel',
    amount: 'Price Per Unit',
  },
  filters: {
    communicationChannel: 'Communication Channel',
    amount: 'Price Per Unit',
  },
  validation: {
    selectChannel: 'Select Channel',
    enterValidPrice: 'Enter valid price',
  },
  sections: {
    pricing: 'Pricing Details',
  },
  help: {
    pricing: 'Set the default price charged per message for each communication channel.',
    createBanner: 'Add a new default price for a communication channel.',
    editBanner: 'Update the default price for this communication channel.',
  },
  create: {
    title: 'Create Pricing',
  },
  edit: {
    title: 'Edit Pricing',
  },
  delete: {
    title: 'Delete pricing for "%{recordName}"',
    content: 'Are you sure you want to delete this pricing entry? This action cannot be undone.',
  },
  notifications: {
    created: 'Pricing saved successfully',
    updated: 'Pricing saved successfully',
    deleted: 'Pricing deleted successfully',
  },
};

export default messages;
